import axios from 'axios'

import { SearchKeysResponse } from 'common/server/server_types'

export function search_key() {
  return axios.get<SearchKeysResponse>('/vendor/order_materials/search_key')
}
